module.exports = __webpack_public_path__ + "img/logo-white-header.bfd3257b.svg";